import {
  type EditionCategoryDetailResponse,
  getCategoriesByEdition,
} from '@api/categories-by-edition-api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

interface UseCategoriesResult {
  categories: EditionCategoryDetailResponse[];
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useCategories(editionId: string | undefined): UseCategoriesResult {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey: ['categories', editionId],
    queryFn: () => getCategoriesByEdition(editionId!),
    enabled: !!editionId,
  });

  const refetch = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: ['categories', editionId] });
  }, [queryClient, editionId]);

  return {
    categories: data ?? [],
    isLoading: !!editionId && isLoading,
    error: error ? (error instanceof Error ? error.message : 'Failed to load categories') : null,
    refetch,
  };
}
